// Utility to detect current runtime platform (Android Capacitor App vs. Web Browser Companion)

export function isAndroidPlatform(): boolean {
  try {
    // Check if Capacitor object is available on window or imported
    const win = window as unknown as { Capacitor?: { getPlatform?: () => string } };
    if (win.Capacitor && typeof win.Capacitor.getPlatform === 'function') {
      return win.Capacitor.getPlatform() === 'android';
    }
  } catch {
    // fallback
  }
  return false;
}

export function isWebCompanionPlatform(): boolean {
  return !isAndroidPlatform();
}

export const APP_VERSION = "1.0.12";

export async function getAppVersion(): Promise<string> {
  if (isAndroidPlatform()) {
    try {
      const { App } = await import("@capacitor/app");
      const info = await App.getInfo();
      if (info?.version) {
        return info.version;
      }
    } catch {
      // fallback
    }
  }
  return APP_VERSION;
}
